import { render, staticRenderFns } from "./AdList.vue?vue&type=template&id=2456e5b4&scoped=true&"
import script from "./AdList.vue?vue&type=script&lang=js&"
export * from "./AdList.vue?vue&type=script&lang=js&"
import style0 from "./AdList.vue?vue&type=style&index=0&id=2456e5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456e5b4",
  null
  
)

export default component.exports